<template>
  <div
    :class="{ 'border-t-4 border-brand-600': !content.coverImage }"
    :data-widget-title="content.title.text"
  >
    <SanityBackground
      class="cover"
      :class="{ 'full-width': content.layout === 'boxed_100' }"
      :image="content.coverImage"
      :lazy="false"
    />
    <div class="px-box-4">
      <SliceTitle
        class="title text-left"
        :class="[
          content.coverImage ? 'mt-7 sm:mt-9 lg:mt-11' : 'pt-box-4',
          content.layout === 'boxed_66' ? 'mb-6 md:mb-9 lg:mb-11' : 'pb-4 border-b border-gray-300',
        ]"
        :value="content.title"
      />
      <div
        v-if="
          content.layout === 'boxed_66' &&
          (page?.author || page?.reviewer || content.affiliateDisclosure || page?.lastUpdated)
        "
        class="grid gap-2 grid-cols-2 w-full md:grid-rows-1 md:flex md:items-end border-b border-t border-dotted py-4 text-13"
      >
        <ArticleAuthor
          v-if="page?.author"
          class="flex md:pr-2 order-1"
          :author="page.author"
          :role="$t('article_title.author')"
        />
        <ArticleAuthor
          v-if="page?.reviewer"
          class="flex md:pr-2 order-2"
          :author="page.reviewer"
          :role="$t('article_title.reviewer')"
          no-image
        />
        <div
          v-if="page?.lastUpdated"
          class="flex self-start sm:self-center md:pr-2"
          :class="{ 'order-2': !page.reviewer, 'order-3 ml-11 sm:ml-0': page.reviewer }"
          data-id="article-date"
        >
          <NuxtTime :datetime="page.lastUpdated" :locale="$lang" date-style="medium" />
        </div>
        <div
          class="flex self-start sm:self-center"
          :class="{
            'order-2': !page?.reviewer && !page?.lastUpdated,
            'order-3 self-start sm:self-center ml-11 sm:ml-0':
              Boolean(page?.reviewer) !== Boolean(page?.lastUpdated), // XOR
            'order-4': page?.reviewer,
          }"
        >
          <MTooltip
            v-if="content.affiliateDisclosure"
            toggle-class="font-semibold underline cursor-pointer"
            tooltip-class="flex self-start sm:self-center"
            trigger="clickToToggle"
          >
            <template #toggle>
              {{ $t('affiliate_disclosure.title') }}
            </template>
            <template #content="{ close }">
              <p>{{ $t('article_title.affiliate_disclosure_description') }}</p>
              <a class="link" target="_blank" rel="noopener" :href="$t('links.trust_monito')">
                {{ $t('read_more') }}
              </a>
              <button class="btn btn-xs btn-amber ml-auto block" @click="close">
                {{ $t('got_it') }}
              </button>
            </template>
          </MTooltip>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import type { GQLPageMeta } from '@core/composables/use-page-meta/generated/page-meta'
import type { GQLArticleTitleSlice } from './generated/article-title'
import ArticleAuthor from './article-author.vue'

defineProps<{ content: GQLArticleTitleSlice }>()

const page = inject<GQLPageMeta>('pageContext')
</script>

<style scoped>
.cover {
  padding-top: 55%;
}

@screen sm {
  .cover {
    padding-top: 43%;
  }
  .cover.full-width {
    padding-top: 30%;
  }
}
</style>
